module.exports = __webpack_public_path__ + "static/media/growth.8d0842fe.png";